import { Sparkles } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { FormField } from '@/components/ui/form-field'
import { Input } from '@/components/ui/input'

export type PersonLinkedInDraftStatus = 'idle' | 'drafting' | 'drafted' | 'failed'

type PersonLinkedInPasteProps = {
  linkedinUrl: string
  onLinkedinUrlChange: (value: string) => void
  status: PersonLinkedInDraftStatus
  error?: string | null
  disabled?: boolean
  onDraft: () => void
}

export function PersonLinkedInPaste({
  linkedinUrl,
  onLinkedinUrlChange,
  status,
  error,
  disabled = false,
  onDraft,
}: PersonLinkedInPasteProps) {
  const drafting = status === 'drafting'
  const statusText =
    status === 'drafting'
      ? 'Drafting from LinkedIn…'
      : status === 'drafted'
        ? 'Draft ready. Nothing was written to your profile.'
        : error || "Couldn't draft from that LinkedIn link."

  return (
    <div className="space-y-2">
      <FormField label="LinkedIn profile link" htmlFor="person-prefill-linkedin">
        <Input
          id="person-prefill-linkedin"
          value={linkedinUrl}
          onChange={(event) => onLinkedinUrlChange(event.target.value)}
          placeholder="linkedin.com/in/..."
          disabled={disabled || drafting}
          inputMode="url"
          autoComplete="url"
        />
      </FormField>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled || drafting || !linkedinUrl.trim()}
        onClick={onDraft}
      >
        <Sparkles aria-hidden />
        {drafting ? 'Drafting…' : 'Draft from LinkedIn'}
      </Button>
      {status !== 'idle' ? (
        <p
          className={status === 'failed' ? 'text-sm text-destructive' : 'text-sm text-muted-foreground'}
          role="status"
        >
          {statusText}
        </p>
      ) : null}
    </div>
  )
}

/** LinkedIn paste is omitted when person prefill is off. */
export function CvUploadLinkedInSlot({
  enabled,
  ...props
}: PersonLinkedInPasteProps & { enabled: boolean }) {
  if (!enabled) return null
  return <PersonLinkedInPaste {...props} />
}
